import { Stack } from 'libs/ui';

import { Fields } from './Fields';

export interface FormContentProps {
  enabledLastStateReRegistrationDate?: boolean;
}

export const FormContent = ({
  enabledLastStateReRegistrationDate,
}: FormContentProps) => (
  <Stack spacing={24} spacingMobile={16}>
    <Fields
      enabledLastStateReRegistrationDate={enabledLastStateReRegistrationDate}
    />
  </Stack>
);
